import React from 'react'
import { Link } from 'react-router-dom'

import { routes } from '../../constants/routes'

import MainNav from '../navs/main'

const NotFound = () => {
    return (
        <>
            <MainNav noBanner={true} />
            <div className="container">
                <div className="title-header">
                    <img src="/img/layout/404-notice.png" alt="page not found graphic" className="mb-5" />
                    <h1>Page Not Found</h1>
                    <p className="mb-5">
                        We can't find the page you're looking for.<br />
                        You can either return to the previous page, visit our homepage or contact our support team.
                    </p>
                    <Link className="btn blue mr-4" to={routes.index}>Visit Homepage</Link>
                    <Link className="btn pale" to={routes.contact}>Contact Us</Link>
                </div>
            </div>
        </>
    )
}

export default NotFound
